import styled from '@emotion/styled'

import { BayMachineUse } from '../../../../utils'
import { toHourMinText } from '../../../../utils/time'

import { BayName } from './BayName'


interface BayItemUseProps extends BayMachineUse {
  size?: 'lg' | 'md' | 'sm'
}

const StyledBayItemUse = styled.div`
  position: relative;
  padding: 10px 16px;
  width: 100%;
  height: 100%;
  background-color: ${({theme: {pallete}}) => pallete.gray[700]};

  &.sm {
    padding: 8px 12px;
  }
`

const TimeContainer = styled.div`
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
`

const TimeReader = styled.p`
  padding: 0 16px;
  margin: 0;

  &.lg {
    font-size: 22px;
    margin-bottom: 8px;
  }

  &.md {
    font-size: 18px;
    margin-bottom: 4px;
  }

  &.sm {
    font-size: 12px;
    margin-bottom: 2px;
  }
`

const TimeBar = styled.div<{ percent?: number; isPrivte?: 0 | 1 }>`
    width: ${({percent}) => percent}%;
    height: 6px;
    background: ${({isPrivte}) =>
    isPrivte
      ? 'linear-gradient(270deg, #C18F0D 0%, #FE0 100%)'
      : 'linear-gradient(270deg, #012E73 0%, #008FFF 100%)'};
`

export default function BayItemUse(info: BayItemUseProps) {
  let timeReader

  if (!info.timer) {
    timeReader = '-'
  } else if (info.timer.remainTime === 0) {
    timeReader = '연습종료'
  } else {
    timeReader = toHourMinText(info.timer.remainTime)
  }

  return (
    <StyledBayItemUse data-testid="bay-use" className={info.size}>
      <BayName className={info.size}>{info.name}</BayName>
      <TimeContainer>
        <TimeReader className={info.size} role="timer">{timeReader}</TimeReader>
        <TimeBar
          data-testid="time-bar"
          percent={info.timer?.remainTimePercent || 0}
          isPrivte={info.private}
        />
      </TimeContainer>
    </StyledBayItemUse>
  )
}
